import { useState, useEffect } from 'react'
import './Navigation.css'

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      setMobileMenuOpen(false)
    }
  }

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="logo-group" onClick={() => scrollToSection('hero')}>
          <img
            src="/janacode.png"
            alt="Janacode"
            className="logo-img"
          />
        </div>
        
        <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
          <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about') }}>About</a>
          <a href="#sectors" onClick={(e) => { e.preventDefault(); scrollToSection('sectors') }}>Content</a>
          <a href="#products" onClick={(e) => { e.preventDefault(); scrollToSection('products') }}>Products</a>
          <a href="#philosophy" onClick={(e) => { e.preventDefault(); scrollToSection('philosophy') }}>Philosophy</a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact') }}>Contact</a>
        </div>

        <button className="nav-cta" onClick={() => scrollToSection('contact')}>
          Get in Touch
        </button>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  )
}

export default Navigation
